import { render, staticRenderFns } from "./RoundedCard.vue?vue&type=template&id=e5014c28&scoped=true&"
import script from "./RoundedCard.vue?vue&type=script&lang=js&"
export * from "./RoundedCard.vue?vue&type=script&lang=js&"
import style0 from "./RoundedCard.vue?vue&type=style&index=0&id=e5014c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5014c28",
  null
  
)

export default component.exports